// full IDL at https://gist.github.com/cnek/d7fdc027120658748c4f92463369307a
// only need the account below for our integration.

export type UXDStakingAccountIDL = {
  version: "2.0.0";
  name: "single_side_staking";
  instructions: [];
  accounts: [
    {
      name: "stakingAccount";
      type: {
        kind: "struct";
        fields: [
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "isInitialized";
            type: "bool";
          },
          {
            name: "user";
            type: "publicKey";
          },
          {
            name: "stakingOptionIdentifier";
            type: "u8";
          },
          {
            name: "stakeEndTs";
            type: "u64";
          },
          {
            name: "stakedAmount";
            type: "u64";
          },
          {
            name: "rewardAmount";
            type: "u64";
          },
          {
            name: "version";
            type: "u8";
          },
          {
            name: "governingTokenVault";
            type: "publicKey";
          },
          {
            name: "governingTokenVaultBump";
            type: "u8";
          },
        ];
      };
    },
  ];
};

export const UXDStakingAccountJSON: UXDStakingAccountIDL = {
  version: "2.0.0",
  name: "single_side_staking",
  instructions: [],
  accounts: [
    {
      name: "stakingAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bump",
            type: "u8",
          },
          {
            name: "isInitialized",
            type: "bool",
          },
          {
            name: "user",
            type: "publicKey",
          },
          {
            name: "stakingOptionIdentifier",
            type: "u8",
          },
          {
            name: "stakeEndTs",
            type: "u64",
          },
          {
            name: "stakedAmount",
            type: "u64",
          },
          {
            name: "rewardAmount",
            type: "u64",
          },
          {
            name: "version",
            type: "u8",
          },
          {
            name: "governingTokenVault",
            type: "publicKey",
          },
          {
            name: "governingTokenVaultBump",
            type: "u8",
          },
        ],
      },
    },
  ],
};
